"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const source_1 = require("../source");
const loader_1 = require("../error/loader");
/**
 * Loads template from the filesystem.
 *
 * @author Fabien Potencier <fabien@symfony.com>
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingLoaderArray {
    constructor(templates) {
        this.TwingLoaderInterfaceImpl = this;
        let map = new Map();
        if (Array.isArray(templates)) {
            let i = 0;
            for (let template of templates) {
                map.set(i++, template);
            }
        }
        else if (typeof templates[Symbol.iterator] === 'function') {
            for (let [name, template] of templates) {
                map.set(name, template);
            }
        }
        else if (typeof templates === 'object') {
            for (let name in templates) {
                map.set(name, templates[name]);
            }
        }
        this.templates = map;
    }
    setTemplate(name, template) {
        this.templates.set(name, template);
    }
    getSourceContext(name) {
        if (!this.exists(name)) {
            throw new loader_1.TwingErrorLoader(`Template "${name}" is not defined.`);
        }
        return new source_1.TwingSource(this.templates.get(name), name);
    }
    exists(name) {
        return this.templates.has(name);
    }
    getCacheKey(name) {
        if (!this.exists(name)) {
            throw new loader_1.TwingErrorLoader(`Template "${name}" is not defined.`);
        }
        return name + ':' + this.templates.get(name);
    }
    isFresh(name, time) {
        if (!this.exists(name)) {
            throw new loader_1.TwingErrorLoader(`Template "${name}" is not defined.`);
        }
        return true;
    }
    resolve(name) {
        return name;
    }
}
exports.TwingLoaderArray = TwingLoaderArray;
